import "./index";
import "./index.css";

import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header"></header>
        <Dictionary />
      </div>
    </div>
  );
}

export default App;
